import { Stack, Typography, Grid, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { NavLink } from "react-router-dom";
import { rarities } from "../rarities";

const useStyles = makeStyles({
  root: {
    zIndex: 9,
    borderRadius: "10px",
    // transition: "background 0s ease-in-out",
    // "&:hover": {
    //   background:
    //     "url(https://test.app.shiryoinu.com/viewbtn.svg) no-repeat center center / auto, linear-gradient(rgba(0,0,0,0.25),rgba(0,0,0,0.25))",
    // },
  },
});

export default function OfferAvatar({ item, index, isLoaded, market, price }) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <NavLink
        to={market ? `/market/${item.card.itemId}` : `/my-packs/${item.type}`}
      >
        <Box
          sx={{
            position: "relative",
            border: "1px solid rgba(56,59,77,0.3)",
            textAlign: "center",
            width: "170px",
            height: "237px",
            borderRadius: "10px",
            margin: { xs: "0 auto", md: "unset" },

            zIndex: "-9",
          }}
        >
          <img
            src={`../${item.type}pack.png`}
            alt={item.type}
            style={{
              width: "100%",
              padding: "32px"
            }}
          />

          <Stack
            sx={{
              p: 1,
              position: "absolute",
              bottom: "4px",
              left: "4px",
              right: "4px",
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                sx={{ fontWeight: "bold", fontSize: "10px", color: "#fff" }}
              >
                SHIRYO
              </Typography>
              <Typography
                sx={{
                  fontSize: "10px",
                  color: item.type === "base" ? rarities["common"] : rarities["legendary"],
                  fontWeight: "bold",
                }}
              >
                {item.type && item.type.toUpperCase()}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography sx={{ fontSize: "10px", color: "#93A3AF" }}>
                QTY: {item.quantity ?? item.card.amount}
              </Typography>
              <Typography sx={{ fontSize: "10px", color: "#93A3AF" }}>
                PACKS
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </NavLink>
    </Box>
  );
}
